module.exports = __webpack_public_path__ + "static/media/heattread-4.5912e184.jpg";